import {useMemo} from 'react'
import styled from 'styled-components'
import {Box, Text, TextButton} from '@binance/uikit'
import useRouter from 'hooks/useRouter'
import useUserLoginStatus from 'hooks/useUserLoginStatus'
import useFee from 'hooks/useFee'
import Tooltip from 'components/Tooltip'
import {isTestnet, FEE_DETAIL} from 'constants'

const StyledTextButton = styled(TextButton)`
  position: absolute;
  top: 12px;
  text-align: center;
  cursor: text;

  & > div > span {
    width: 16px;
    height: 16px;
    line-height: 16px;
    border: 1px solid #848e9c;

    &:hover {
      color: rgba(132, 142, 156, 0.7);
      border-color: rgba(132, 142, 156, 0.7);
    }
  }
`

const StyledBox = styled(Box)`
  display: flex;
  justify-content: space-between;
  font-weight: normal;

  .line-through {
    color: #848e9c;
    text-decoration: line-through;
    font-style: normal;
    margin-right: 3px;
  }
`

const Link = styled.a`
  color: #f0b90b;
  text-decoration: none;
  &:hover {
    color: #f6cb43;
  }
`

export default function FeeBtn ({i18n}) {
  const router = useRouter()
  const {lng} = router.query
  const isLogin = useUserLoginStatus()
  const calcCommission = (commission = 0, hasBNB) => {
    const DENOMINATOR = 1000000
    const RATE = 0.75

    if (hasBNB) {
      return `${(commission * RATE * 100) / DENOMINATOR}%`
    }
    return `${(commission * 100) / DENOMINATOR}%`
  }
  const {
    feeTier, makerCommission, takerCommission, hasBNB
  } = useFee()

  const tipText = useMemo(
    () => (
      <>
        <StyledBox width="100%" mb={4}>
          <Text.Base color="#fff" fontSize={14}>
            {i18n['fee-feeTierLabel'] || 'Fee Tier'}: {feeTier}
          </Text.Base>
          <Text.Base color="primary" fontSize={12}>
            <Link href={FEE_DETAIL[lng]} target="_blank">
              {i18n['fee-detailsLink'] || 'Details'} >>
            </Link>
          </Text.Base>
        </StyledBox>
        {hasBNB && (
          <StyledBox width="100%" mb={4}>
            <Text.Base color="#fff" fontSize={12}>
              {i18n['fee-usingBNB'] || 'Using BNB for fees (25% discount)'}
            </Text.Base>
          </StyledBox>
        )}
        <StyledBox width="100%" borderTop="1px solid rgba(255, 255, 255, .1)" pt={4}>
          <Text.Base color="#fff" fontSize={12}>
            {i18n['fee-feeLabel'] || 'Fee'}: {i18n['fee-takerLabel'] || 'Taker'}(
            {hasBNB ? (
              <>
                <em className="line-through">{calcCommission(takerCommission)}</em>
                {calcCommission(takerCommission, hasBNB)}
              </>
            ) : (
              calcCommission(takerCommission)
            )}
            )
          </Text.Base>
          <Text.Base color="#fff" fontSize={12} ml={4}>
            {i18n['fee-makerLabel'] || 'Maker'}(
            {hasBNB ? (
              <>
                <em className="line-through">{calcCommission(makerCommission)}</em>
                {calcCommission(makerCommission, hasBNB)}
              </>
            ) : (
              calcCommission(makerCommission)
            )}
            )
          </Text.Base>
        </StyledBox>
      </>
    ),
    [feeTier, hasBNB, i18n, lng, makerCommission, takerCommission]
  )

  return useMemo(
    () => (
      <>
        {isLogin && !isTestnet ? (
          <StyledTextButton color="#848E9C" right={lng === 'cn' ? '50px' : '75px'}>
            <Tooltip label={'$'} tip={tipText} style={{whiteSpace: 'nowrap', minWidth: 'auto'}} />
          </StyledTextButton>
        ) : null}
      </>
    ),
    [isLogin, lng, tipText]
  )
}
